module.exports = __webpack_public_path__ + "static/5fdaddf94d1f666fccc96db0aee97a9c2a4a2e65be7c33ee7f12296258f70bed-875b61d7cbccc6d0038be9ac517ca8ee.png";